import React from 'react';

export default function FwCoinsIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-coins' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
